// ============================================================
// components/Footer.jsx
// ============================================================

import React from "react";

export default function Footer({ setCurrentView }) {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-col">
          <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "0.5rem" }}>
            <div style={{ width: 50, height: 50, borderRadius: "50%", overflow: "hidden", flexShrink: 0 }}>
              <img src="/logo.jpg" alt="Chaitimecrunch" style={{ width: "108%", height: "108%", objectFit: "cover", marginLeft: "-4%", marginTop: "-4%" }} />
            </div>
            <h4>Chaitime<span style={{ color: "var(--chai-light)" }}>crunch</span></h4>
          </div>
          <p>Handcrafted cakes, cookies & pastries made with love in Beau Bassin, Mauritius.</p>
        </div>
        <div className="footer-col">
          <h4>Quick Links</h4>
          <a onClick={() => setCurrentView("menu")}>Our Menu</a>
          <a onClick={() => setCurrentView("book")}>Book an Order</a>
          <a onClick={() => setCurrentView("loyalty")}>Loyalty Rewards</a>
          <a onClick={() => setCurrentView("about")}>About Us</a>
        </div>
        <div className="footer-col">
          <h4>Contact</h4>
          <p>Beau Bassin, Plaines Wilhems</p>
          <p>+230 5710 0994</p>
          <p>hello@chaitimecrunch.mu</p>
        </div>
        <div className="footer-col">
          <h4>Hours</h4>
          <p>Mon — Fri: 8AM — 6PM</p>
          <p>Saturday: 8AM — 4PM</p>
          <p>Sunday: 9AM — 2PM</p>
        </div>
      </div>
      <div className="footer-bottom">
        © 2026 Chaitimecrunch. All rights reserved. Built with love & chai.
      </div>
    </footer>
  );
}